import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as S from "./AdminLogin.styled";
import logo from "assets/logo.png";
import { adminAuthService } from "services/adminAuthService";

const AdminLogin: React.FC = () => {
  const [loginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    setErrorMessage("");

    if (!loginId.trim()) {
      setErrorMessage("아이디를 입력해주세요.");
      return;
    }
    if (!password.trim()) {
      setErrorMessage("비밀번호를 입력해주세요.");
      return;
    }

    setIsLoading(true);
    try {
      const response = await adminAuthService.login({ loginId, password });
      localStorage.setItem('accessToken', response.accessToken);
      localStorage.removeItem('guestMode');
      navigate("/admin");
    } catch (error: any) {
      if (error.response?.status === 401) {
        setErrorMessage("아이디 또는 비밀번호가 일치하지 않습니다.");
      } else {
        setErrorMessage("로그인에 실패했습니다. 다시 시도해주세요.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") handleLogin();
  };

  return (
    <S.Page>
      {/* ── 좌측 브랜딩 패널 ── */}
      <S.LeftPanel>
        <S.LeftTop>
          <S.LogoImg src={logo} alt="지금 우리 학교는" />
          <S.LeftTitle>
            캠퍼스의 모든 것을<br />
            <span>한눈에</span> 관리하세요
          </S.LeftTitle>
          <S.LeftDesc>
            시설 예약 현황, 회원 관리, 공지사항까지<br />
            관리자 포털에서 효율적으로 운영하세요.
          </S.LeftDesc>
        </S.LeftTop>

        <S.LeftBottom>
          <S.LeftStat>
            <span />
            <span>시설 예약 현황 실시간 모니터링</span>
          </S.LeftStat>
          <S.LeftStat>
            <span />
            <span>회원 및 가입 요청 관리</span>
          </S.LeftStat>
          <S.LeftStat>
            <span />
            <span>공지사항 · FAQ · 문의 관리</span>
          </S.LeftStat>
        </S.LeftBottom>
      </S.LeftPanel>

      {/* ── 우측 로그인 폼 ── */}
      <S.RightPanel>
        <S.FormCard>
          <S.FormTitle>관리자 로그인</S.FormTitle>
          <S.FormSubtitle>관리자 계정으로 로그인하세요</S.FormSubtitle>

          <S.FieldGroup>
            <div>
              <S.FieldLabel htmlFor="loginId">아이디</S.FieldLabel>
              <S.FieldWrap>
                <S.Input
                  id="loginId"
                  type="text"
                  placeholder="아이디를 입력하세요"
                  value={loginId}
                  onChange={(e) => setLoginId(e.target.value)}
                  onKeyDown={handleKeyDown}
                  autoComplete="username"
                />
              </S.FieldWrap>
            </div>

            <div>
              <S.FieldLabel htmlFor="password">비밀번호</S.FieldLabel>
              <S.FieldWrap>
                <S.Input
                  id="password"
                  type="password"
                  placeholder="비밀번호를 입력하세요"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyDown={handleKeyDown}
                  autoComplete="current-password"
                />
              </S.FieldWrap>
            </div>

            {errorMessage && <S.ErrorMsg>{errorMessage}</S.ErrorMsg>}
          </S.FieldGroup>

          <S.LoginButton onClick={handleLogin} disabled={isLoading}>
            {isLoading ? "로그인 중..." : "로그인"}
          </S.LoginButton>

          <S.Divider>
            <span>관리자 계정이 없으신가요?</span>
          </S.Divider>

          <S.SignupRequestButton to="/admin/signup-request">
            관리자 가입 요청
          </S.SignupRequestButton>

          <S.BackLink to="/login">← 사용자 로그인으로 돌아가기</S.BackLink>
        </S.FormCard>
      </S.RightPanel>
    </S.Page>
  );
};

export default AdminLogin;
